<template>
  <div ref="panel" class="manual-study-panel" tabindex="-1">
    <div class="cyber-info">
      <el-image v-if="portraitUrl" class="cyber-info-img" :src="portraitUrl"
                :preview-src-list="[portraitUrl]" fit="cover" />
      <div v-else class="cyber-info-img portrait-empty">—</div>
      <div class="cyber-info-detail summary-detail">
        <span>D科1当前: {{ formatHours(subjectSummary(1).learnedSeconds) }}/10学时</span>
        <span>D科4当前: {{ formatHours(subjectSummary(4).learnedSeconds) }}/8学时</span>
        <span>科1已上报 {{ formatHours(subjectSummary(1).reportedSeconds) }}，待同步 {{ subjectSummary(1).pendingCount || 0 }} 条</span>
        <span>科4已上报 {{ formatHours(subjectSummary(4).reportedSeconds) }}，待同步 {{ subjectSummary(4).pendingCount || 0 }} 条</span>
        <el-button type="primary" size="mini" @click="$emit('refresh')">刷新</el-button>
      </div>
      <div class="cyber-info-detail form-detail">
        <span class="field-label">修改已提交时间</span>
        <el-input v-model="reportedTime" size="mini" :disabled="!reportedRecord" placeholder="暂无已提交记录" />
        <el-button type="primary" size="mini" :disabled="!reportedRecord" @click="updateReportedTime">
          修改已提交时间
        </el-button>
      </div>
      <div class="cyber-info-detail form-detail">
        <span class="field-label">待提交结束时间</span>
        <el-input v-model="pendingEndTime" size="mini" :disabled="!pendingRecord" placeholder="暂无待提交记录" />
        <el-button type="primary" size="mini" :disabled="!pendingRecord" @click="updatePendingEndTime">
          修改观看结束时间
        </el-button>
        <span class="field-label">待提交时长(秒)</span>
        <el-input v-model="pendingDurationSeconds" size="mini" :disabled="!pendingRecord" placeholder="暂无待提交记录" />
        <el-button type="primary" size="mini" :disabled="!pendingRecord" @click="updatePendingDuration">
          修改学时(秒)
        </el-button>
      </div>
      <div class="cyber-info-detail verify-detail">
        <UploadImg ref="verifyUpload" button-title="上传认证照片" @uploadSuccess="updateVerifyPhoto" />
        <el-button type="danger" size="mini" :disabled="!portraitId" @click="deleteVerifyPhoto">删除认证照片</el-button>
      </div>
    </div>

    <div class="submit-container">
      <div class="submit-field time-field">
        <span>结束观看时间</span>
        <el-input ref="endTimeInput" v-model="endTime" size="small" placeholder="YYYY-MM-DD HH:mm:ss" />
        <div class="quick-actions">
          <el-button size="mini" @click="setTime(-4)">前4天</el-button>
          <el-button size="mini" @click="setTime(-3)">前3天</el-button>
          <el-button size="mini" @click="setTime(-2)">前2天</el-button>
          <el-button size="mini" @click="setTime(-1)">前1天</el-button>
          <el-button size="mini" @click="setTime(0)">今天</el-button>
        </div>
        <div class="quick-actions">
          <el-button size="mini" @click="setTime(1)">可提交第1天</el-button>
          <el-button size="mini" @click="setTime(2)">可提交第2天</el-button>
          <el-button size="mini" @click="setTime(3)">可提交第3天</el-button>
          <el-button size="mini" @click="setTime(4)">可提交第4天</el-button>
          <el-button size="mini" @click="setTime(5)">可提交第5天</el-button>
        </div>
      </div>
      <div class="submit-field">
        <span>提交时长(秒)</span>
        <el-input v-model="durationSeconds" size="small" />
        <div class="quick-actions">
          <el-button size="mini" @click="durationSeconds = 16200">16200</el-button>
          <el-button size="mini" @click="durationSeconds = 11545">11545</el-button>
        </div>
      </div>
      <div class="submit-field subject-field">
        <span>提交科目</span>
        <el-radio v-model="forceSubject" label="1">科1</el-radio>
        <el-radio v-model="forceSubject" label="4">科4</el-radio>
      </div>
      <div class="submit-field submit-action">
        <el-button type="primary" size="small" :loading="submitting" @click="submitStudy">提交学时</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import UploadImg from '@/components/system/uploadImg.vue'
import { deleteVerifyImg, updateVerifyImg } from '@/api/studentDetail'
import {
  createMotorcycleLearningRecord,
  reportMotorcycleRecord,
  updateMotorcyclePendingRecord,
  updateMotorcycleReportedTime
} from '@/api/motorcycleLearning'
import { formatHours } from '@/utils/motorcycleLearning'

export default {
  name: 'MotorcycleManualStudyPanel',
  components: { UploadImg },
  props: {
    detail: { type: Object, required: true }
  },
  data () {
    return {
      reportedTime: '',
      pendingEndTime: '',
      pendingDurationSeconds: '',
      endTime: '',
      durationSeconds: 16200,
      forceSubject: '1',
      submitting: false
    }
  },
  computed: {
    student () {
      return this.detail.student || {}
    },
    photos () {
      return this.detail.photos || {}
    },
    portraitUrl () {
      return this.photos.portraitUrl || ''
    },
    portraitId () {
      return this.photos.portraitId || null
    },
    reportedRecord () {
      return this.latestRecord(['REPORTED'])
    },
    pendingRecord () {
      return this.latestRecord(['READY_REPORT', 'FAILED'])
    }
  },
  watch: {
    detail: {
      immediate: true,
      handler () {
        this.syncRecordInputs()
      }
    }
  },
  methods: {
    formatHours,
    focus () {
      this.$nextTick(() => {
        this.$refs.panel.focus()
        this.$refs.endTimeInput.focus()
      })
    },
    subjectSummary (subject) {
      return (this.detail.subjectSummaries || []).find(item => item.subject === subject) || {}
    },
    latestRecord (statuses) {
      return (this.detail.records || [])
        .filter(record => statuses.includes(record.status))
        .sort((left, right) => Number(right.id) - Number(left.id))[0] || null
    },
    syncRecordInputs () {
      this.reportedTime = this.reportedRecord ? (this.reportedRecord.reportedAt || this.reportedRecord.endTime) : ''
      this.pendingEndTime = this.pendingRecord ? this.pendingRecord.endTime : ''
      this.pendingDurationSeconds = this.pendingRecord ? this.pendingRecord.durationSeconds : ''
      this.forceSubject = this.pendingRecord ? String(this.pendingRecord.subject) : '1'
    },
    trainingStart () {
      if (!this.student.openclassesdate) return null
      const startTime = dayjs(this.student.openclassesdate)
      return startTime.isValid() ? startTime : null
    },
    setTime (day) {
      const now = dayjs()
      const trainingStart = this.trainingStart()
      if (!trainingStart) {
        this.$message.error('学员开训时间不正确')
        return
      }
      let selected = day <= 0
        ? now.add(day, 'day')
        : trainingStart.add(day - 1, 'day').hour(23).minute(58).second(32)
      if (selected.isBefore(trainingStart)) {
        this.$message.warning('结束观看时间不能早于开训时间')
        return
      }
      if (selected.isAfter(now)) {
        this.$message.warning('结束观看时间不能晚于当前时间')
        return
      }
      this.endTime = selected.format('YYYY-MM-DD HH:mm:ss')
    },
    validDateTime (value, label) {
      const date = dayjs(value)
      if (!date.isValid()) {
        this.$message.error(`${label}格式不正确`)
        return null
      }
      return date
    },
    validDuration (value) {
      const duration = Number(value)
      if (!Number.isInteger(duration) || duration <= 0) {
        this.$message.error('学习时长必须为正整数秒')
        return null
      }
      return duration
    },
    async updateReportedTime () {
      const reportedTime = this.validDateTime(this.reportedTime, '已提交时间')
      if (!reportedTime) return
      const res = await updateMotorcycleReportedTime({
        recordId: this.reportedRecord.id,
        reportedTime: reportedTime.format('YYYY-MM-DD HH:mm:ss')
      })
      if (res.code === 0) {
        this.$message.success('修改已提交时间成功')
        this.$emit('refresh')
      }
    },
    async updatePending (endTime, durationSeconds, subject) {
      const res = await updateMotorcyclePendingRecord({
        recordId: this.pendingRecord.id,
        endTime,
        durationSeconds,
        subject
      })
      if (res.code === 0) {
        this.$message.success('待提交学习记录已修改')
        this.$emit('refresh')
      }
    },
    async updatePendingEndTime () {
      const endTime = this.validDateTime(this.pendingEndTime, '待提交结束时间')
      const durationSeconds = this.validDuration(this.pendingDurationSeconds)
      if (!endTime || !durationSeconds) return
      await this.updatePending(endTime.format('YYYY-MM-DD HH:mm:ss'), durationSeconds, this.pendingRecord.subject)
    },
    async updatePendingDuration () {
      const endTime = this.validDateTime(this.pendingEndTime, '待提交结束时间')
      const durationSeconds = this.validDuration(this.pendingDurationSeconds)
      if (!endTime || !durationSeconds) return
      await this.updatePending(endTime.format('YYYY-MM-DD HH:mm:ss'), durationSeconds, this.pendingRecord.subject)
    },
    async updateVerifyPhoto (files) {
      const uploadedFile = files[files.length - 1]
      if (!uploadedFile || !uploadedFile.fileUrl) return
      const res = await updateVerifyImg({
        img: uploadedFile.fileUrl,
        userId: this.student.uid,
        id: this.portraitId
      })
      if (res.data) {
        this.$message.success('认证照片已更新')
        this.$refs.verifyUpload.clear()
        this.$emit('refresh')
      }
    },
    async deleteVerifyPhoto () {
      await this.$confirm('确认删除认证照片？')
      const res = await deleteVerifyImg({ id: this.portraitId })
      if (res.data) {
        this.$message.success('认证照片已删除')
        this.$emit('refresh')
      }
    },
    resolveSubject () {
      return Number(this.forceSubject)
    },
    async submitStudy () {
      const endTime = this.validDateTime(this.endTime, '结束观看时间')
      const durationSeconds = this.validDuration(this.durationSeconds)
      if (!endTime || !durationSeconds) return
      if (endTime.isAfter(dayjs())) {
        this.$message.error('结束观看时间不能晚于当前时间')
        return
      }
      if (!this.portraitUrl || !/^https:\/\//.test(this.portraitUrl)) {
        this.$message.error('请先上传 HTTPS 认证照片')
        return
      }
      this.submitting = true
      try {
        let recordId
        if (this.pendingRecord) {
          const updateResult = await updateMotorcyclePendingRecord({
            recordId: this.pendingRecord.id,
            endTime: endTime.format('YYYY-MM-DD HH:mm:ss'),
            durationSeconds,
            subject: this.resolveSubject()
          })
          if (updateResult.code !== 0 || !updateResult.data || !updateResult.data.id) return
          recordId = this.pendingRecord.id
        } else {
          const startTime = endTime.subtract(durationSeconds, 'second')
          const createResult = await createMotorcycleLearningRecord({
            userId: this.student.uid,
            subject: this.resolveSubject(),
            startTime: startTime.format('YYYY-MM-DD HH:mm:ss'),
            endTime: endTime.format('YYYY-MM-DD HH:mm:ss'),
            portraitUrl: this.portraitUrl,
            signPhotoUrl: this.portraitUrl,
            processPhotoUrls: '',
            signOutPhotoUrl: this.portraitUrl,
            actualIp: ''
          })
          if (createResult.code !== 0 || !createResult.data || !createResult.data.id) return
          recordId = createResult.data.id
        }

        const reportResult = await reportMotorcycleRecord(recordId)
        const reportData = reportResult.data || {}
        if (reportResult.code === 0 && reportData.status === 'REPORTED') {
          this.$message.success('学时提交并同步监管成功')
        } else if (reportResult.code === 0 && reportData.status === 'FAILED') {
          this.$message.error(`${reportData.statusMessage}，本地记录已保留可重试`)
        } else {
          this.$message.warning('学习记录已保存，等待重试')
        }
      } finally {
        this.submitting = false
        this.$emit('refresh')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.manual-study-panel { outline: none; }
.cyber-info { display: flex; align-items: flex-start; gap: 10px; }
.cyber-info-img { width: 80px; height: 100px; flex: 0 0 80px; border: 1px solid #dcdfe6; }
.portrait-empty { display: flex; align-items: center; justify-content: center; color: #909399; background: #f5f7fa; }
.cyber-info-detail { display: flex; flex-direction: column; gap: 6px; }
.summary-detail { min-width: 215px; font-size: 12px; line-height: 18px; }
.form-detail { min-width: 180px; }
.verify-detail { min-width: 125px; }
.field-label { color: #606266; font-size: 12px; }
.submit-container { display: flex; gap: 16px; margin-top: 16px; padding: 12px 0; border-top: 1px solid #ebeef5; }
.submit-field { display: flex; flex-direction: column; gap: 8px; min-width: 150px; font-size: 12px; }
.time-field { min-width: 325px; }
.quick-actions { display: flex; gap: 6px; flex-wrap: wrap; }
.subject-field { min-width: 230px; }
.submit-action { justify-content: flex-end; }
</style>
